<template>
  <div class="guarantor-edit">
    <Row :gutter="16">
      <i-col span="14">
        <Form ref="editForm" :model="supervisorModel"
          :rules="modelValidate"
          label-position="left"
          :label-width="120">
          <FormItem label="名称" prop="name">
            <Input v-model="supervisorModel.name" placeholder="输入名称" />
          </FormItem>
          <FormItem label="社会信用代码" prop="businessLicense">
            <Input v-model="supervisorModel.businessLicense" placeholder="输入社会信用代码" />
          </FormItem>
          <FormItem label="法人" prop="legalPerson">
            <Input v-model="supervisorModel.legalPerson" placeholder="输入法人姓名" />
          </FormItem>
          <Form-item label="联系人" prop="contact">
            <Input v-model="supervisorModel.contact" placeholder="联系人姓名"></Input>
          </Form-item>
          <Form-item label="电话" prop="contactTel">
            <Input v-model="supervisorModel.contactTel" placeholder="联系人电话"></Input>
          </Form-item>
          <FormItem>
            <Button type="primary" size="large" long @click="submit">保存</Button>
          </FormItem>
        </Form>
      </i-col>
      <i-col span="8">
      </i-col>
    </Row>
  </div>
</template>

<script>
import Api from './../../api/Api.js'
export default {
  name: 'supervisor-edit',
  props: {
  },
  data () {
    return {
      loading: false,
      supervisorModel: {
        id: null,
        name: null,
        businessLicense: null,
        legalPerson: null,
        contact: null,
        contactTel: null
      },
      modelValidate: {
        name: [
          { required: true, message: '请填写名称', trigger: 'blur' }
        ],
        businessLicense: [
          { required: true, message: '请填写社会信用代码', trigger: 'blur' }
        ],
        legalPerson: [
          { required: true, message: '请填写法人姓名', trigger: 'blur' }
        ],
        contact: [
          { required: true, message: '请填写业务联系人', trigger: 'blur' }
        ],
        contactTel: [
          { required: true, message: '请填写业务联系电话', trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
    '$route.params.supervisorId': function () {
      this.getSupervisorDetail()
    }
  },
  mounted () {
    this.getSupervisorDetail()
  },
  activated () {
  },
  deactivated () {
  },
  methods: {
    getSupervisorDetail () {
      Api.Supervisor.getSupervisorDetail(this.$route.params.supervisorId).then((res) => {
        Object.assign(this.supervisorModel, res)
      }).catch(err => {
        this.$Message.error('获取详情失败!' + err.message)
      })
    },
    async submit () {
      this.$refs.editForm.validate(async (valid) => {
        if (valid) {
          this.loading = true
          this.$Spin.show()
          await Api.Supervisor.updateSupervisor(this.supervisorModel)
            .then((payload) => {
              console.log('suc', payload)
              this.$Message.success('修改成功!')
              this.loading = false
              this.$Spin.hide()
            })
            .catch(err => {
              console.log('err', err)
              this.$Message.error('提交失败!' + err.message)
              this.loading = false
              this.$Spin.hide()
            })
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
</style>
